import MyCustomValidation from "../Js/Validation";

export interface ITblMSogoServiceData {
    pkCompanyCode?: string;
    pkOfficeCode?: string;
    pkServiceType?: string;
    hokenCode?: string;
    serviceType?: string;
    serviceCode?: string;
    kaisibi?: string;
    syuryobi?: string;
    serviceName?: string;
    tanisu?: number;
    santeiTani?: number;
    seigenKaisu?: number;
    santeiKaisuSeigenKikan?: number;
    sikyuGendoTaisyoKbn?: number;
    yobi?: string;
    kyuhuritu?: number;
    hutangaku?: number;
    jigyotaishosyaJissiKbn?: number;
    youshien1JisshiKbn?: number;
    youshien2JisshiKbn?: number;
    youkaigo1JisshiKbn?: number;
    youkaigo2JisshiKbn?: number;
    youkaigo3JisshiKbn?: number;
    youkaigo4JisshiKbn?: number;
    youkaigo5JisshiKbn?: number;
    kokuhorenItakuKbn?: number;
    sakuseiNengappi?: number;
    goseiKbn?: number;
    hiwariKbn?: number;
    id?: number;
    delFlg?: number;
    addDate?: Date | null | undefined;
    addUser?: string;
    updDate?: Date | null | undefined;
    updUser?: string;
    isSelect?: boolean;
}

export class TblMSogoService {
    pkCompanyCode?: string;
    pkOfficeCode?: string;
    pkServiceType?: string;
    hokenCode?: string;
    serviceType?: string;
    serviceCode?: string;
    kaisibi?: string;
    syuryobi?: string;
    serviceName?: string;
    tanisu?: number;
    santeiTani?: number;
    seigenKaisu?: number;
    santeiKaisuSeigenKikan?: number;
    sikyuGendoTaisyoKbn?: number;
    yobi?: string;
    kyuhuritu?: number;
    hutangaku?: number;
    jigyotaishosyaJissiKbn?: number;
    youshien1JisshiKbn?: number;
    youshien2JisshiKbn?: number;
    youkaigo1JisshiKbn?: number;
    youkaigo2JisshiKbn?: number;
    youkaigo3JisshiKbn?: number;
    youkaigo4JisshiKbn?: number;
    youkaigo5JisshiKbn?: number;
    kokuhorenItakuKbn?: number;
    sakuseiNengappi?: number;
    goseiKbn?: number;
    hiwariKbn?: number;
    id?: number;
    delFlg?: number;
    addDate?: Date | null | undefined;
    addUser?: string;
    updDate?: Date | null | undefined;
    updUser?: string;
    isSelect?: boolean;

    constructor(data: ITblMSogoServiceData = {}) {
        this.pkCompanyCode = data.pkCompanyCode || '';
        this.pkOfficeCode = data.pkOfficeCode || '';
        this.pkServiceType = data.pkServiceType || '';
        this.hokenCode = data.hokenCode || '';
        this.serviceType = data.serviceType || '';
        this.serviceCode = data.serviceCode || '';
        this.kaisibi = data.kaisibi || '';
        this.syuryobi = data.syuryobi || '';
        this.serviceName = data.serviceName || '';
        this.tanisu = data.tanisu || 0;
        this.santeiTani = data.santeiTani || 0;
        this.seigenKaisu = data.seigenKaisu || 0;
        this.santeiKaisuSeigenKikan = data.santeiKaisuSeigenKikan || 0;
        this.sikyuGendoTaisyoKbn = data.sikyuGendoTaisyoKbn || 0;
        this.yobi = data.yobi || '';
        this.kyuhuritu = data.kyuhuritu || 0;
        this.hutangaku = data.hutangaku || 0;
        this.jigyotaishosyaJissiKbn = data.jigyotaishosyaJissiKbn || 0;
        this.youshien1JisshiKbn = data.youshien1JisshiKbn || 0;
        this.youshien2JisshiKbn = data.youshien2JisshiKbn || 0;
        this.youkaigo1JisshiKbn = data.youkaigo1JisshiKbn || 0;
        this.youkaigo2JisshiKbn = data.youkaigo2JisshiKbn || 0;
        this.youkaigo3JisshiKbn = data.youkaigo3JisshiKbn || 0;
        this.youkaigo4JisshiKbn = data.youkaigo4JisshiKbn || 0;
        this.youkaigo5JisshiKbn = data.youkaigo5JisshiKbn || 0;
        this.kokuhorenItakuKbn = data.kokuhorenItakuKbn || 0;
        this.sakuseiNengappi = data.sakuseiNengappi || 0;
        this.goseiKbn = data.goseiKbn || 0;
        this.hiwariKbn = data.hiwariKbn || 0;
        this.id = data.id || 0;
        this.delFlg = data.delFlg || 0;
        this.addDate = data.addDate || null;
        this.addUser = data.addUser || '';
        this.updDate = data.updDate || null;
        this.updUser = data.updUser || '';
        this.isSelect = data.isSelect || false;
    }

    clear(): void {
        this.pkCompanyCode = '';
        this.pkOfficeCode = '';
        this.pkServiceType = '';
        this.hokenCode = '';
        this.serviceType = '';
        this.serviceCode = '';
        this.kaisibi = '';
        this.syuryobi = '';
        this.serviceName = '';
        this.tanisu = 0;
        this.santeiTani = 0;
        this.seigenKaisu = 0;
        this.santeiKaisuSeigenKikan = 0;
        this.sikyuGendoTaisyoKbn = 0;
        this.yobi = '';
        this.kyuhuritu = 0;
        this.hutangaku = 0;
        this.jigyotaishosyaJissiKbn = 0;
        this.youshien1JisshiKbn = 0;
        this.youshien2JisshiKbn = 0;
        this.youkaigo1JisshiKbn = 0;
        this.youkaigo2JisshiKbn = 0;
        this.youkaigo3JisshiKbn = 0;
        this.youkaigo4JisshiKbn = 0;
        this.youkaigo5JisshiKbn = 0;
        this.kokuhorenItakuKbn = 0;
        this.sakuseiNengappi = 0;
        this.goseiKbn = 0;
        this.hiwariKbn = 0;
        this.id = 0;
        this.delFlg = 0;
        this.addDate = null;
        this.addUser = '';
        this.updDate = null;
        this.updUser = '';
        this.isSelect = false;
    }

    // カスタムバリデーションメソッド
    validate(): string[] {
        const errors: string[] = [];

        // const validation = new MyCustomValidation("")
        //     .validateRequired("車両コードは必須です。")
        //     .validateNumeric("車両コードを正しく入力してください。")
        //     .validateStringRange(
        //         "0",
        //         "9999999999",
        //         "車両コードを正しく入力してください。"
        //     );
        // if (validation.hasErrors()) {
        //     errors.push(validation.getErrors()[0]);
        // }

        // その他のバリデーションルールをここに追加

        return errors;
    }
}
